import fetch from '@/config/fetch';

/**
 * 数据修改审核
 */
export const dataModificationList = data => fetch('/platform/tranportChildUpdate/audit/page', data, 'GET');
export const dataModificationDetailList = data => fetch('/platform/tranportChildUpdate/audit/detail', data, 'GET');
export const dataModificationAgreeOrRefuse = data => fetch('/platform/tranportChildUpdate/audit/agreeOrRefuse', data, 'POST');

/**
 * 审核人员管理
 */
export const auditTypeSelectList = data => fetch('/platform/sys/auditType/selectList', data, 'POST');

export const auditHierarchySelectList = id => fetch(`/platform/sys/auditHierarchy/selectList/${id}`, {}, 'POST');

export const selectListByHierarchyId = id => fetch(`/platform/sys/auditorConfig/selectListByHierarchyId/${id}`, {}, 'POST');

export const empDeptListByEmpName = data => fetch('/platform/sys/essDept/empDeptListByEmpName', data, 'POST');

export const empDeptListByEmpName1 = data => fetch('/platform/essEmployee/getUserByDepartmentId', data, 'GET');

export const addOrUpdate = data => fetch('/platform/sys/auditHierarchy/addOrUpdate', data, 'POST');

export const auditHierarchyDelete = data => fetch('/platform/sys/auditHierarchy/delete', data, 'POST');
// 审核层级
export const getAuditHierarchy = data => fetch('/platform/sys/auditHierarchy/getAuditHierarchy', data, 'GET');
// 获取列表数据
export const selectListByHierarchy = data => fetch('/platform/sys/auditorConfig/selectListByHierarchy', data, 'GET');
// 新增层级
export const addAuditHierarchy = data => fetch(`/platform/sys/auditHierarchy/add?auditType=${data}`, {}, 'POST');
// 删除层级
export const deleteAuditHierarchy = data => fetch(`/platform/sys/auditHierarchy/delete?auditType=${data}`, {}, 'POST');
// 获取审核人员
export const getEmployee = data => fetch(`/platform/sys/auditorConfig/selectUser?hierarchyId=${data}`, {}, 'GET');
export const getEmployee2 = data => fetch(`/platform/sys/auditorConfig/selectUser2?hierarchyId=${data}`, {}, 'GET');

// 新增审核人员
export const addEmployee = data => fetch(`/platform/sys/auditorConfig/add${data}`, {}, 'POST');
// 删除审核人员
export const deleteEmployee = data => fetch(`/platform/sys/auditorConfig/delete/${data}`, {}, 'POST');


/**
 * 委托商审核
 */
export const customerExaminePageList = data => fetch('/platform/sys/customerExamine/pageList', data, 'GET');

export const customerExamineDetail = id => fetch(`/platform/sys/customerExamine/detail/${id}`, {}, 'GET');


/**
 * 运输车审核
 */
// 分页查询
export const transporterPageList = data => fetch('/platform/highwayCar/truckExaminePageList', data, 'GET');
// 详情
export const transporterDetail = id => fetch(`/platform/highwayCar/auditDetails/${id}`, {}, 'GET');
// 同意/拒绝
export const transporterReviewSubmit = data => fetch('/platform/highwayCar/reviewSubmit', data, 'POST');


/**
 * 供应商培训审核
 */
export const auditPageListPageList = data => fetch('/platform/busi/trainRecord/auditPageList', data, 'POST');

export const trainRecordReviewSubmit = data => fetch('/platform/busi/trainRecord/reviewSubmit', data, 'POST');

export const trainRecordDetail = data => fetch('/platform/busi/trainRecord/detail', data, 'GET');

export const customerExamineReviewSubmit = data => fetch('/platform/sys/customerExamine/reviewSubmit', data, 'POST');

/**
 * 委托商审核
 */
export const dailyReviewAuditPageList = data => fetch('/platform/busi/dailyReview/auditPageList', data, 'POST');

export const dailyReviewDetail = data => fetch('/platform/busi/dailyReview/detail', data, 'GET');

export const dailyReviewReviewSubmit = data => fetch('/platform/busi/dailyReview/reviewSubmit', data, 'POST');

/**
 * 公路供应商审核
 */
export const highwaySupplierAuditPageList = data => fetch('/platform/highwaySupplier/auditPageList', data, 'GET');

export const highwaySupplierReviewSubmit = data => fetch('/platform/highwaySupplier/reviewSubmit', data, 'POST');

export const highwaySupplierAuditDetail = data => fetch(`/platform/highwaySupplier/auditDetail/${data.id}`, data, 'GET');


/**
 * 合同价格审核
 */
export const auditPageList = data => fetch('/platform/busi/priceReview/auditPageList', data, 'POST');

export const busiPriceReviewType = data => fetch('/platform/paramCategoryAttr/selectCategoryAttr', data, 'GET');

export const priceReviewDetail = data => fetch('/platform/busi/priceReview/detail/', data, 'GET');

export const reviewSubmit = data => fetch('/platform/busi/priceReview/reviewSubmit', data, 'POST');

/**
 * 其他费用审核
 */
// 详情
export const othercostCtherCostDetail = id => fetch(`/platform/othercost/auditDetail/${id}`, {}, 'GET');
// 审核
export const othercostReviewSubmit = data => fetch('/platform/othercost/reviewSubmit', data, 'POST');

/**
 * 抵扣开票费用审核
 */
// 分页查询
export const deductPageList = data => fetch('/platform/deductionInvoicingCost/auditPageList', data, 'GET');
// 详情
export const deductDetail = id => fetch(`/platform/deductionInvoicingCost/auditDetail/${id}`, {}, 'GET');
// 审核
export const deductReviewSubmit = data => fetch('/platform/deductionInvoicingCost/reviewSubmit', data, 'POST');


/**
 * 合同审核
 */
// 分页
export const contractAffairsExaminePpageList = data => fetch('/platform/contractAffairs/examinePpageList', data, 'GET');
// 详情
export const contractAffairsExamineDetail = id => fetch(`/platform/contractAffairs/examineDetail/${id}`, {}, 'GET');

/**
 * 燃油费审核
 */
// 审核
export const auditFuelCost= data => fetch('/platform/settlement/supplierPortOther/reviewSubmit', data, 'POST');
